import { config } from '@iheartjane/config';

import { request } from '../lib/request';

interface GetProductsParams {
  force_without_location?: boolean;
  lat?: number | undefined;
  long?: number | undefined;
  max_search_radius?: number | undefined;
  product_ids: (string | number)[];
}

export class ProductsSource {
  static buildUrl(url = '') {
    return `${config.apiPath}/products${url}`;
  }

  static getProduct(id: string | number, store_id?: string | number) {
    return request(
      this.buildUrl(`/${id}`),
      {
        method: 'GET',
      },
      { store_id }
    );
  }

  static getProducts(params: GetProductsParams) {
    return request(this.buildUrl(), { method: 'GET' }, params);
  }
}
